import axios from 'axios'
import store from '@/store'
import router from '@/router'
import utils from './utils.js';
import {
	ElMessage
} from 'element-plus'
// const baseURL ='http://59.110.154.69:8022'
const baseURL ='http://192.168.0.119:8022'
const service = axios.create({
	baseURL: '/api',
	// baseURL: baseURL,
	timeout: 20000 // request timeout
})
// 请求拦截器
service.interceptors.request.use(
	config => {

		config.headers['Banben'] = '1';
		config.headers['Device'] = '4';
		config.headers['Deviceid'] = '1';
		config.headers['Timestamp'] = '1';

		let token = localStorage.getItem('token');
		// console.log(token,'token')

		config.headers['token'] = token ? token : '';
		console.table(
			`%capi%c${ config.url }%c${ config.method }\n%c${ JSON.stringify(config.params?._data) }`,
			'background:green;font-size: 16px;border-radius: 4px;color:white;padding: 0 4px;margin-right: 8px', 'color: blue;font-size: 16px',
			'background: gold;font-size: 16px;border-radius: 2px;box-shadow: 2px 2px 2px 2px orange;color: purple;font-weight: bold;padding: 0 4px; margin-left: 6px',
			'border:1px dashed blue;color:orange;margin-right: 8px;margin-top: 6px;font-size:17px;',
		)
		if (config?.params?. ['_data']) {
			Object.assign(config.params, {
				data: utils.Encrypt(JSON.stringify(config.params['_data']))
			})
			delete config.params['_data']
		}

		// console.log(config.url )
		return config
	},
	error => {
		// do something with request error
		console.error(error) // for debug
		return Promise.reject(error)
	}
)

// response interceptor响应拦截器
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
		const res = response.data;
		// console.log(response,'111')
		if (res.status == 200) {
			if (res.data) {
				res.data = utils.Decrypt(res.data);
				console.log(res.data, 'resdata')
				console.table(res?.data?.records||res.data)
				if (res.data || res.data === 0) {
					return res.data;
				} else {
					return res;
				}
			} else {
				return res;
			}
		} else {
			if (response.headers['content-type'] == "image/png") {
				return res
			} else if (response.request.responseType == 'blob') {
				return res;
			} else {
				if (res.status == 401) {
					store.commit('setToken', '');
					localStorage.clear();
					router.push('/login');
					ElMessage({
						message: '登录失效，请重新登录！',
						type: 'error',
						duration: 5 * 1000
					})
					return Promise.reject(res)
				} else {
					console.log(res)
					ElMessage.error(res.message);
					return Promise.reject(res)
				}
				// Message.error(res.msg);
			}
		}
	},
	error => {
		console.error(error, error.type)
		if (error instanceof axios.Cancel) {
		} else if (error.message == 'Request failed with status code 413') {
			ElMessage({
				message: '文件大于8M，上传失败！',
				type: 'error',
				duration: 5 * 1000
			})
		} else {
			ElMessage({
				message: error.message,
				type: 'error',
				duration: 5 * 1000
			})
		}
		return Promise.reject(error)
	}
)

export default service
